import type { ReactNode } from 'react';

export interface DataColumn<T> {
  header: string;
  render: (row: T, index: number) => ReactNode;
}

type Props<T> = {
  columns: DataColumn<T>[];
  rows: T[];
  rowKey?: (row: T, index: number) => string | number;
};

/** Plain bordered table of already loaded rows (no filters / sorting / pagination). */
export function DataTable<T>({ columns, rows, rowKey = (_, index) => index }: Props<T>) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="table table-bordered">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.header}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={rowKey(row, index)}>
              {columns.map((column) => (
                <td key={column.header}>{column.render(row, index)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
